import React from 'react'
import { Container, Table } from 'react-bootstrap'

export const ReportTable = ({ data, filterName, headers }) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
        return (
            <div className="mt-3 p-0" style={{ margin: "0% 2.5%" }}>
                <div className="alert alert-info">
                    No data available for the selected report.
                </div>
            </div>
        )
    }
    return (
        <Container
            fluid
            style={{
                fontFamily: "'Poppins', sans-serif",
            }}
            className="mt-3 p-0"
        >
            <div className="table-container mb-2" style={{ height: "100%" }}>
                <Table className="listStyleForContact" style={{ overflowY: "auto" }}>
                    <thead>
                        <tr style={{ textAlign: "start" }}>
                            <th>#</th>
                            {headers.map((header, index) => (
                                <th key={index}>
                                    {header
                                        .replace(/_/g, " ")
                                        .replace(/\b\w/g, (l) => l.toUpperCase())}
                                </th>
                            ))}
                            {/* Action */}
                            <th style={{ padding: "0 !important" }}></th>
                        </tr>
                    </thead>
                    <tbody style={{ textAlign: "start" }}>
                        {data?.length !== 0 ? (
                            data.map((row, rowIndex) => (
                                <React.Fragment key={rowIndex}>
                                    <tr
                                        style={{
                                            marginTop: "10px",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        <td>{rowIndex + 1}</td>
                                        {headers.map((header, cellIndex) => (
                                            <td
                                                key={cellIndex}
                                                style={{
                                                    textTransform: header !== "email" && "capitalize",
                                                }}
                                            >
                                                {Array.isArray(row[header])
                                                    ? row[header].join(", ")
                                                    : row[header] || "-"}
                                            </td>
                                        ))}
                                        <td
                                            className="lastactionTd"
                                            style={{
                                                padding: "0px !important",
                                                // zIndex: openRow === rowIndex ? 11 : "auto",
                                                zIndex: "auto",
                                            }}
                                        >
                                            <div className="endTdDiv">
                                                {/* <Dropdown
                                                as="div"
                                                className="dropdownsWithoutToggle"
                                                onToggle={(isOpen) =>
                                                    setOpenRow(isOpen ? rowIndex : null)
                                                }
                                                >
                                                <Dropdown.Toggle
                                                    as={Nav.Link}
                                                    className="header-link"
                                                >
                                                    <FontAwesomeIcon
                                                    icon={faEllipsisVertical}
                                                    style={{
                                                        fontSize: "15px",
                                                        width: "20px",
                                                        color: "#536485",
                                                    }}
                                                    />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu
                                                    align={"end"}
                                                    style={{
                                                    width: "8rem",
                                                    inset: "0px auto auto 0px",
                                                    boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                                                    position: "absolute",
                                                    marginTop: "-22px",
                                                    marginRight: "25px",
                                                    minWidth: "3rem",
                                                    }}
                                                >
                                                    <Dropdown.Item
                                                    style={{
                                                        fontSize: "12px",
                                                        padding: "4px 21px",
                                                    }}
                                                    className="d-flex align-items-center btn"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                    }}
                                                    >
                                                    Download
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                                </Dropdown> */}
                                            </div>
                                        </td>
                                    </tr>
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td
                                    // colSpan={
                                    // tempColumns?.length > 0
                                    //         ? tempColumns.length + 1
                                    //         : colSpanCount
                                    // }
                                    className="text-center text-secondary"
                                >
                                    No Data Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </Container>
    )
}